import { tracLinkInitialState } from './initial-state';
import { TracLinkActions } from './action-creators';
import { TracLinkState } from './state';
import * as actions from './actions';
import { TourEvent } from '@common/types/traclink/tour-event';

const tracLinkReducer = (
  state: TracLinkState = tracLinkInitialState,
  action: TracLinkActions
): TracLinkState => {
  switch (action.type) {
    case actions.GET_TOUR_EVENTS_SUCCESS: {
      return {
        ...state,
        tourEvents: [...state.tourEvents, ...action.results],
        tourEventsError: null,
      };
    }

    case actions.GET_TOUR_EVENTS_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }
    case actions.ADD_TOUR_EVENT_SUCCESS: {
      return {
        ...state,
        tourEvents: [...state.tourEvents, action.results],
        tourEventsError: null,
      };
    }

    case actions.ADD_TOUR_EVENT_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }
    case actions.UPDATE_TOUR_EVENT_SUCCESS: {
      const updatedTourEvent = action.results;
      const newTourEvents = state.tourEvents.reduce(
        (acc: TourEvent[], tourEvent) => {
          if (tourEvent.id === updatedTourEvent.id) {
            acc.push(updatedTourEvent);
          } else {
            acc.push(tourEvent);
          }
          return acc;
        },
        []
      );

      return {
        ...state,
        tourEvents: [...newTourEvents],
        tourEventsError: null,
      };
    }

    case actions.UPDATE_TOUR_EVENT_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }
    case actions.DELETE_TOUR_EVENT_SUCCESS: {
      const newTourEvents = state.tourEvents.filter(
        (tour) => tour.id !== action.tourId
      );

      return {
        ...state,
        tourEvents: [...newTourEvents],
        tourEventsError: null,
      };
    }

    case actions.DELETE_TOUR_EVENT_ERROR: {
      return {
        ...state,
        tourEventsError: action.code,
      };
    }

    default:
      return state;
  }
};

export default tracLinkReducer;
